// Where "Fix it" sends you for each kind of pixel problem.
export function fixHref(fix) {
  if (!fix) return null;
  if (fix.where === "main") return `/admin/pixels?fix=${fix.field}`;
  if (fix.where === "page") return `/admin/landing-pages/custom/${fix.page_id}?fix=pixels${fix.field ? `&field=${fix.field}` : ""}`;
  if (fix.where === "tracking") return fix.id ? `/admin/tracking-approvals?review=${fix.id}` : "/admin/tracking-approvals?fix=kill";
  return null;
}

export const FIELD_LABEL = {
  meta_pixel_id: "Meta pixel ID",
  google_ads_id: "Google Ads ID",
  google_ads_conversion_label: "Google Ads conversion label",
  ga4_measurement_id: "GA4 measurement ID",
  tiktok_pixel_id: "TikTok pixel ID",
};

// Scroll the first matching setting into view and focus it.
export function focusFixTarget(...selectors) {
  setTimeout(() => {
    const el = selectors.map((s) => document.querySelector(s)).find(Boolean);
    if (!el) return;
    el.scrollIntoView({ block: "center", behavior: "smooth" });
    if (el.tagName === "INPUT" || el.tagName === "BUTTON") el.focus({ preventScroll: true });
  }, 200);
}

export const HIGHLIGHT = "ring-4 ring-amber-400 ring-offset-2";
